<script>
export default {
  data() {
    return {
      isDesktop: window.matchMedia('(min-width: 1024px)'),
    };
  },

  mounted() {
    this.isDesktop.addEventListener('change', () => {
      this.updateDevice();
    });

    this.updateDevice();
  },

  methods: {
    updateDevice() {
      if (!this.isDesktop.matches) {
        this.$store.commit('page/setValue', {key: 'deviceType', value: 'mobile'});
      } else {
        this.$store.commit('page/setValue', {key: 'deviceType', value: 'desktop'});
      }
    },
  },
};
</script>
